export default __webpack_public_path__ + "static/media/Add_to_Apple_Wallet_rgb_NO.2abcf4e1.svg";